import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format an ISO timestamp as a Danish "Opdateret X siden" trust label.
 * Used as a freshness hint next to data sourced from the Bilinfo sync —
 * shown on /om-os and /biler-til-salg.
 *
 * Falls back to "Opdateres snart" when no sync has happened yet, and to a
 * locale date string for syncs older than a week (relative time stops being
 * useful past that point).
 */
export function formatSyncedHint(iso: string | null | undefined): string {
  if (!iso) return "Opdateres snart";
  const diffMs = Date.now() - new Date(iso).getTime();
  if (!Number.isFinite(diffMs) || diffMs < 0) return "Opdateret lige nu";
  const mins = Math.floor(diffMs / 60_000);
  if (mins < 1) return "Opdateret lige nu";
  if (mins < 60) return `Opdateret for ${mins} ${mins === 1 ? "minut" : "minutter"} siden`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `Opdateret for ${hours} ${hours === 1 ? "time" : "timer"} siden`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `Opdateret for ${days} ${days === 1 ? "dag" : "dage"} siden`;
  return `Opdateret ${new Date(iso).toLocaleDateString("da-DK")}`;
}
